/**
 * Backwards-compatible redirect: `/developer/audit-log` → `/research/audit-log`.
 * Keeps the query string, so a filtered link still opens on the same filters.
 */
import { Navigate, useLocation } from "react-router-dom";
import { ROUTES } from "@/routes";

export default function LegacyAuditLogRedirect() {
  const { search } = useLocation();
  return <Navigate to={`${ROUTES.research.auditLog}${search}`} replace />;
}
